import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type TreeFilter,
} from '../types/filters';
import { roleDefinition, roleHandler } from './role';

export const multiRoleDefinition: FilterDefinition<MultiFilter<TreeFilter>> = {
  id: FilterId.MULTI_ROLE,
  name: 'Role',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.ROLE,
  instances: [],
  isVisible: true,
};

export const multiRoleHandler: FilterHandler<MultiFilter<TreeFilter>> = {
  isActive(currentFilterState: MultiFilter<TreeFilter>) {
    return currentFilterState.instances.some((instance) =>
      roleHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      roleHandler.getEffectiveFilter(instance, roleDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
